

/* tslint:disable */



export enum FindingType {
    Boolean = 1,
    Quantity = 2,

}


